/**
 * Wrapper para $fetch com baseURL da API e credenciais.
 * Uso: const api = useApi(); await api('/deals', { method: 'POST', body: data })
 */
export function useApi() {
  const config = useRuntimeConfig()
  const api = $fetch.create({
    baseURL: config.public.apiBaseUrl,
    credentials: 'include',
  })

  return async <T>(request: Parameters<typeof $fetch<T>>[0], options?: Parameters<typeof $fetch<T>>[1]) => {
    try {
      return await api<T>(request, options)
    }
    catch (error) {
      const status = typeof error === 'object' && error && 'statusCode' in error
        ? Number((error as { statusCode?: number }).statusCode)
        : undefined

      if (status !== 401) {
        throw error
      }

      try {
        const { refreshSession } = useAuth()
        await refreshSession()
        return await api<T>(request, options)
      }
      catch {
        await navigateTo('/login')
        throw error
      }
    }
  }
}
